module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraLightItalic.c45b539.eot";